import RecommendationCardsPDF from './RecommendationCardsPDF';

export default RecommendationCardsPDF;
